import Icon from '../components/Icon.vue'

Icon.register({
  download: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M216 0H296C309.3 0 320 10.7 320 24V192H407.7C425.5 192 434.4 213.5 421.8 226.1L269.7 378.3C262.2 385.8 249.9 385.8 242.4 378.3L90.1 226.1C77.5 213.5 86.4 192 104.2 192H192V24C192 10.7 202.7 0 216 0zM512 376V488C512 501.3 501.3 512 488 512H24C10.7 512 0 501.3 0 488V376C0 362.7 10.7 352 24 352H170.7L219.7 401C239.8 421.1 272.2 421.1 292.3 401L341.3 352H488C501.3 352 512 362.7 512 376zM388 464C388 453 379 444 368 444S348 453 348 464 357 484 368 484 388 475 388 464zM452 464C452 453 443 444 432 444S412 453 412 464 421 484 432 484 452 475 452 464z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/download.js
// module id = i71b
// module chunks = 144